import { createContext } from "react";

const parentContext = createContext();

export default parentContext;
